/** Loads the bespoke client config generated by the LLM. */

import type { ClientConfig } from "../types/diagnostic";

let _cache: ClientConfig | null = null;

/** Load client-config.json from public/data/. */
export async function loadClientConfig(): Promise<ClientConfig> {
  if (_cache) return _cache;
  const resp = await fetch("/data/client-config.json");
  if (!resp.ok) {
    throw new Error(
      "Failed to load client-config.json. Run the diagnostic in Cursor first."
    );
  }
  _cache = (await resp.json()) as ClientConfig;
  return _cache;
}
